
<template>
  <div class="toolTip-box">
    <div class="conttent">
      <div class="pic" :style="{backgroundImage: 'url('+ imgSrc +')'}"></div>
      <p>{{text}}<a href="javascript:;" @click="goHelp()">这里</a></p>
      <div class="btn-box">
        <button class="f-l btn cancel" @click="cancelHandle()">知道了</button>
      </div>
    </div>
  </div>
</template>
<script>
import Common from '../../assets/js/common.js'
export default {
  props: {
    text: {
      type: String,
      default: '请确保设备处于正在联网状态，数据同步需要一点时间。如果不知道如何联网，请点'
    }
  },
  data () {
    return {
      imgSrc: Common.staticHref() + 'img/onUse.jpg'
    }
  },
  name: 'TtipSelect2',
  methods: {
    cancelHandle () {
      this.$emit('noshow')
    },
    goHelp () {
      this.$router.push({path: '/Question'})
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/mixins.styl'
.toolTip-box
  position absolute
  top 0
  left 0
  right 0
  bottom 0
  z-index 99999999
  background rgba(0,0,0,.5)
  text-align center
  rowCloCenter()
  .conttent
    background #ffffff
    width 343px
    border-radius 10px
    colmCenter()
    .pic
      height 12.9vh
      width calc(12.9vh * 2.24)
      background-position center center
      background-repeat no-repeat
      background-size contain
      margin 41px auto 0
    p
      line-height 21px
      font-size 15px
      color #333333
      text-align center
      border-bottom 1px solid #ededed
      padding 12px 36px
    .btn-box
      .btn
        width 100%
        height 57px
        color #333333
        background #b5b5b5
        font-size 16px
        color #ffffff
        border-bottom-left-radius 10px
        border-bottom-right-radius 10px
</style>


// WEBPACK FOOTER //
// src/components/TtipSelect2/TtipSelect2.vue